import React, { Component } from 'react';
import JitsiMeetJS from '../../base/lib-jitsi-meet';
import { ASSET_VERSION_QUERY } from '../../utils/assetVersionQuery';
/**
 * React component representing unsupported browser page.
 *
 * @class DefaultUnsupportedDesktopBrowser
 */
class DefaultUnsupportedDesktopBrowser extends Component {
    /**
     * Redirects to the static recommended browsers page or the WebRTC unsupported page.
     * IE and other browsers without WebRTC support will show the WebRTC unsupported page.
     *
     * @returns {void}
     */
    componentDidMount() {
        if (!JitsiMeetJS.isWebRtcSupported()) {
            window.location.pathname = 'static/webrtcUnsupported.html';
        }
        else {
            window.location.pathname = 'static/recommendedBrowsers.html';
        }
    }
    /**
     * Renders the component.
     *
     * @returns {ReactElement}
     */
    render() {
        return (React.createElement("div", { className: "contenitore" },
            React.createElement("header", null,
                React.createElement("span", { className: "logo" },
                    React.createElement("img", { className: "logo-img", src: `images/meeting-logo.svg${ASSET_VERSION_QUERY}`, alt: "#" }),
                    React.createElement("span", { className: "logo-text" }, "Meeting"))),
            React.createElement("section", { className: "container" },
                React.createElement("div", { className: "container_section left flex-center" },
                    React.createElement("div", { className: "box" },
                        React.createElement("img", { className: "img-alert", src: `images/alert.png${ASSET_VERSION_QUERY}`, alt: "#" }),
                        React.createElement("h4", null, "Ci dispiace ma il browser che stai utilizzando non \u00E8 supportato"),
                        React.createElement("h4", { className: "light" }, "Prova con un browser diverso come Google Chrome e assicurati che sia aggiornato all\u2019ultima versione"),
                        React.createElement("hr", null),
                        React.createElement("h4", null, "Oppure scarica la app Vianova Meeting e collegati dal tuo smartphone"))),
                React.createElement("div", { className: "container_section right flex-start" },
                    React.createElement("div", { className: "box" },
                        React.createElement("img", { className: "img-phone", src: `images/phone.png${ASSET_VERSION_QUERY}`, alt: "#" }),
                        React.createElement("div", { className: "store" },
                            React.createElement("a", { href: "https://play.google.com/store/apps/details?id=it.vianova.meet" },
                                React.createElement("img", { src: `images/android.png${ASSET_VERSION_QUERY}`, alt: "Android", style: { maxWidth: "109px" } })),
                            React.createElement("a", { href: "https://apps.apple.com/it/app/id1507145324" },
                                React.createElement("img", { src: `images/ios.png${ASSET_VERSION_QUERY}`, alt: "iOS", style: { maxWidth: "97px" } })))))),
            React.createElement("footer", null,
                React.createElement("span", null,
                    React.createElement("img", { className: "", src: `images/logoVianova.svg${ASSET_VERSION_QUERY}`, alt: "#" })))));
    }
}
export default DefaultUnsupportedDesktopBrowser;
